import React, { useState, useRef, useEffect } from "react";
import * as CC from "../style/skill-details-konsult-style";
//import * as NWD from "../style/tjanster-infopage-style";
import starSkill from "../../assets/at-details/starSkill.svg";


const SkillInfo: Record<string, { title: string; text: string }> = {
	arkitektur: {
		title: "Systemarkitektur",
		text: "Med vår långa erfarenhet från olika branscher och verksamheter hjälper vi er att skapa en teknisk plan som är både hållbar och flexibel. Vi designar lösningar som inte bara löser dagens utmaningar, utan som också kan växa och anpassas över tid. Och det bästa? Oavsett vilka utvecklare som tar över om fem år, kommer systemet att vara lätt att underhålla och vidareutveckla. För oss handlar det inte bara om att bygga teknik – det handlar om att bygga en framtid där ni har full kontroll.",
	},
	systemutveckling: {
		title: "Systemutveckling",
		text: "Vi älskar att koda! Ren, enkel och genomtänkt kod som löser behovet. Våra utvecklare brinner för att skapa lösningar som inte bara fungerar idag, utan som också håller i längden. Med vår expertis inom .NET och React bygger vi system utan onödigt krångel – stabila, effektiva och anpassade efter just era behov. För oss är det viktigt att ni får en lösning som är hållbar, lätt att underhålla och redo för framtiden. Det som är viktigt för er är viktigt för oss. Vi är experter inom Frontendutveckling (React), Backend och API-lösningar (.NET, Node.js, Next.js) och Systemintegrationer (Azure Functions, BizTalk)",
	},
	devops: {
		title: "DevOps",
		text: "Tänk er att ni kan leverera nya mjukvaruversioner snabbt och tryggt – utan onödiga hinder. Det är en riktig konkurrensfördel, eller hur? Med bra DevOps strategi får ni just det . Vi på Andtech har över tio års erfarenhet av att implementera skalbara och hållbara DevOps-lösningar.Vi tror på shift left – att automatisera tester och säkerhetskontroller tidigt i utvecklingsprocessen. På så sätt upptäcks problem innan de blir kostsamma, och ni sparar både tid och resurser.Låt oss hjälpa er att skapa optimerade och säkra DevOps-pipelines som minskar risker, effektiviserar arbetet och stärker samarbetet mellan utveckling och drift. För i slutändan handlar det inte bara om verktygen – det handlar om hur vi arbetar smartare.",
	},
	azure_effektiviseringar: {
		title: "Azure effektivisering",
		text: "Känner ni igen er i att molnkostnaderna bara ökar, utan att ni riktigt vet varför? Det är ofta resultatet av en plattform som vuxit organiskt, där applikationer, databaser och andra resurser hamnat på dyrare betalningsplaner än vad som egentligen behövs – bara för att hantera prestandatoppar. Vi vet hur man optimerar era applikationer, väljer rätt betalningsplaner och utnyttjar skalbarhet för att sänka kostnaderna rejält – utan att tumma på prestanda. Och det bästa? Vi kan ge er en kostnadsanalys för 2000 kr (exkl moms) som snabbt ger er en tydlig bild av hur mycket ni kan spara. Enkelt och smididgt eller hur? Ska vi ta en titt?",
	},
};

export const AndtechConsultantSkills: React.FC = () => {
	const [selectedSkill, setSelectedSkill] = useState<string | null>(null);

const skillRef = useRef<HTMLDivElement | null>(null);

const handleClick = (key: string) => {
	setSelectedSkill(prev => (prev === key ? null : key)); // Toggle utan att ta bort från DOM
};

useEffect(() => {
	if (selectedSkill && skillRef.current) {
		setTimeout(() => {
			skillRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
		}, 100); // DOM får tid att uppdatera innan scroll
	}
}, [selectedSkill]);


	return (
		<CC.SkillCardWrapper>
			
			<CC.SkillDetails>
				<CC.SkillIcon src={starSkill} alt="" aria-hidden="true" />
				<CC.SkillsList>
					{Object.entries(SkillInfo).map(([key, skill]) => (
						<CC.SkillItem key={key}>
							<CC.StyledSkillLink onClick={() => handleClick(key)}>
								{skill.title}
							</CC.StyledSkillLink>
						</CC.SkillItem>
					))}
				</CC.SkillsList>
			</CC.SkillDetails>

			<CC.FlexContainer ref={skillRef} className={selectedSkill ? "visible" : "hidden"}>
		{selectedSkill && (
			<>
				<CC.KonsultDetailHeader>{SkillInfo[selectedSkill].title}</CC.KonsultDetailHeader>
				<CC.KonsultDetailText>{SkillInfo[selectedSkill].text}</CC.KonsultDetailText>
			</>
		)}
	</CC.FlexContainer>
		</CC.SkillCardWrapper>
	);
};
